import localKey from "./localKey";

const devApiUrl = "/";

const proApiUrl = "https://dev.sj.api.fxzb.vip/";
// const proApiUrl = "http://192.168.110.201:8117/";
// const proApiUrl = 'https://sj.api.fxzb.vip/';

// const wssUrl = 'wss://sj.api.fxzb.vip'
const wssUrl = 'wss://dev.sk-m.api.fxzb.vip'
// const wssUrl = 'ws://192.168.110.124:8049'
// const wssUrl = 'ws://192.168.110.48:8049'
const nodeDevEnv = process.env.NODE_ENV == "development" ? true : false;

export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: "店掌云助手",
    minSiteMame: "C",
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 60000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: "Authorization",
    shopMemberId:'shopMemberId',
    shopIds:'shopIds',
    member:'member',
    userInfoKey: "USER_INFO",
    ...localKey,
    socketUrl:  wssUrl,
};
